import {AppServices} from "../../config/entities";
import {DocumentTransactionDto} from "../../dtos/transactions/DocumentTransactionDto";

export class TransactionService {
    async getDocumentTransactions(documentId: string): Promise<DocumentTransactionDto> {
        const url = `/transactions/${documentId}`;
        const response = await AppServices.Axios.get(url);
        console.log(response.data);
        return response.data;
    }
}